import { render } from "./Integrity.vue?vue&type=template&id=12ffae5e&scoped=true"
import script from "./Integrity.vue?vue&type=script&lang=js"
export * from "./Integrity.vue?vue&type=script&lang=js"

import "./Integrity.vue?vue&type=style&index=0&id=12ffae5e&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ffae5e"]])

export default __exports__